export default {
  /**
   * 验证手机号码格式是否正确
   * @param {number|string} phoneNumber - phone number
   * @return {boolean} result - true/false
   */
  validatePhone(phoneNumber) {
    return /^1[3456789]\d{9}$/.test(phoneNumber)
  },

  /**
   * 手机号脱敏
   * @param {number|string} phoneNumber - phone number
   * @return {string} result - 123****4567
   */
  phoneDesensitization(phoneNumber) {
    if (this.validatePhone(phoneNumber)) {
      const reg = /^(\d{3})\d{4}(\d{4})$/
      return (phoneNumber + '').replace(reg, '$1****$2')
    }
    return phoneNumber
  },

  getUUID() {
    let s = []
    let hexDigits = '0123456789abcdef'
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'
    s[19] = hexDigits.substr((+s[19] & 0x3) | 0x8, 1)
    s[8] = s[13] = s[18] = s[23] = '-'
    return s.join('')
  },
}
